import * as React from 'react';
import ReactPaginate from 'react-paginate';
export interface IPaginationProps<T>
  extends React.ClassAttributes<PaginationComponent<T>> {
  readonly pageCount: number;
  readonly pageCurrent: number;

  readonly getCurrentPageData: (data: any) => void;
}


export default class PaginationComponent<T> extends React.Component<
  IPaginationProps<T>
> {
  constructor(props: IPaginationProps<T>) {
    super(props);
   
  }

  render() {
    const { pageCount } = this.props;
    return (
      <>
        <ReactPaginate
          nextLabel="next >"
          onPageChange={this.handlePageClick}
          pageRangeDisplayed={3}
          marginPagesDisplayed={2}
          pageCount={pageCount}
          forcePage={this.props.pageCurrent}
          previousLabel="< previous"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          containerClassName="pagination"
          activeClassName="active"
          //   renderOnZeroPageCount={null}
        />
      </>
    );
  }

  private handlePageClick = (event: any) => {
    this.props.getCurrentPageData(event.selected);
  };
}



// WEBPACK FOOTER //
// ./src/components/common/Pagination/index.tsx